module.exports = "<spinner backgroundColor=\"#ff0000\" spinner=\"sk-wave\"></spinner>\n<app-header></app-header>\n<router-outlet></router-outlet>\n"